import React from 'react'
import { Modal, Box, Typography, Button, IconButton, useTheme } from '@mui/material'
import { ReactComponent as ChecCircleIcon } from '../../../../../common/images/onboarding/checkCircleIcon.svg'
import CloseIcon from '@mui/icons-material/Close'
import { modalStyle, modalHeaderStyle, modalContentStyle, containedBottomButton } from './launchCampaignStyles'

export default function LaunchConfirmModal({ isOpen, onClose, campaignName = '[Campaign Name]', onViewDetails }) {
  const theme = useTheme()

  return (
    <Modal open={isOpen} onClose={onClose} aria-labelledby='campaign-launch-success-title'>
      <Box sx={modalStyle}>
        <Box sx={modalHeaderStyle(theme)}>
          <Typography variant='h6' component='h2' id='campaign-launch-success-title' sx={{ fontWeight: '600' }}>
            {campaignName}
          </Typography>
          <IconButton aria-label='close' onClick={onClose} sx={{ color: theme.palette.grey[500] }}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box sx={modalContentStyle(theme)}>
          <ChecCircleIcon />
          <Typography variant='h5' component='h3' sx={{ fontWeight: '600', mb: 1 }}>
            Your Phishing Campaign Is Live!
          </Typography>
          <Typography variant='body2' color='text.secondary' sx={{ mb: 3 }}>
            Monitor real-time performance in the Campaigns section and track employee interactions.
          </Typography>
          <Button variant='contained' fullWidth onClick={onViewDetails || onClose} sx={containedBottomButton}>
            View campaign details
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}
